import { useEffect } from 'react';

import { PrivatePage } from '../../components/private-page';
import FacilitatorsGrid from '../../features/facilitators-grid';
import { ctGameDefault, ctGameTitle } from '../../constants/text';

export const Facilitators = () => {
  useEffect(() => {
    document.title = ctGameTitle + '- Facilitators';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        {
          label: 'Dashboard',
          href: 'dashboard'
        },
        {
          label: 'Facilitators',
          href: `facilitators`
        }
      ]}
      pageTitle={'Facilitator management'}>
      <FacilitatorsGrid />
    </PrivatePage>
  );
};
